import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './style.css'
import App from './App.vue'
import router from './router'
import { clickOutside } from './directives/clickOutside'
import { api } from './api/Api'
import { useLoadingStore } from './stores/loading'
import { install } from "vue3-recaptcha-v2";
import { tokenManager } from './api/utils/tokenManager'
import { useDark } from '@vueuse/core'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';

library.add(fas);

const isDark = useDark()
//isDark.value = true 

const savedTheme = tokenManager.getTheme();
if (savedTheme) {
  if (savedTheme == 'dark') {
    isDark.value = true
  }
} else {
  // If no theme is saved, default to system theme
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const defaultTheme = prefersDark ? 'dark' : 'light';
  tokenManager.setTheme(defaultTheme);
  if (defaultTheme == 'dark') {
    isDark.value = true
  }
}

const app = createApp(App)
const pinia = createPinia()


app.component('font-awesome-icon', FontAwesomeIcon)

app.directive('click-outside', clickOutside)
app.use(pinia)

// Initialize loading store for API
const loadingStore = useLoadingStore()
api.setLoadingStore(loadingStore)

// Track route changes
/*
router.beforeEach((to, from) => {
  eventTracker.trackEvent('navigation', 'Route Change', {
    from: from.path,
    to: to.path
  })
})*/

app.use(router)
app.use(install, {
    sitekey: '6Lc-zLgqAAAAAANBXmOZGDxmJDGzwo0nJ9Y9R-mi',
    cnDomains: false,
  })
app.mount('#app')